import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-form-package/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Form, Field, Button } from '../src';
import { Playground } from 'docz';
import { autocapitalize } from 'autocapitalize';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "state-manipulation"
    }}>{`State Manipulation`}</h1>
    <blockquote>
      <p parentName="blockquote">{`How to manipulate the state before it is validated`}</p>
    </blockquote>
    <p>{`Sometimes you need to manipulate the value of a input. It is not recommended, but there are some edge cases and situations where this comes in handy, e.g. you have an input and you have to ensure that the user capitalizes the first letter, e.g. on names.`}</p>
    <p>{`For this use cases there is a property called `}<inlineCode parentName="p">{`preOnChange`}</inlineCode>{`. This property takes a function that returns the new value of the input. You can only manipulate the value of the current input field.`}</p>
    <p>{`The next example manipulates the input value that it always capitalizes the first letter of every word in the input field.`}</p>
    <Playground __position={0} __code={'<Form validate>\n  <div>\n    <div>Name:</div>\n    <Field\n      id=\"name\"\n      type=\"text\"\n      // `value` is the current value of the input field\n      preOnChange={value => autocapitalize(value, \'words\')}\n      required\n    />\n  </div>\n  <div>\n    <Button\n      id=\"submit\"\n      type=\"submit\"\n      onClick={state => {\n        alert(JSON.stringify(state, null, 2))\n        alert(\'open the console to see the whole state...\')\n        console.log(state)\n      }}\n    >\n      Submit\n    </Button>\n  </div>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Field,
      Button,
      Playground,
      autocapitalize
    }} mdxType="Playground">
  <Form validate mdxType="Form">
    <div>
      <div>
        Name:
      </div>
      <Field id="name" type="text" // `value` is the current value of the input field
          preOnChange={value => autocapitalize(value, 'words')} required mdxType="Field" />
    </div>
    <div>
      <Button id="submit" type="submit" onClick={state => {
            alert(JSON.stringify(state, null, 2));
            alert('open the console to see the whole state...');
            console.log(state);
          }} mdxType="Button">
        Submit
      </Button>
    </div>
  </Form>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      